export const safeReplaceInArray = function <T>(
	array: T[],
	index: number,
	replaceWith: T,
) {
	const newArray = [...array];
	newArray.splice(index, 1, replaceWith);
	return newArray;
};

export default safeReplaceInArray;
